import { FC, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Calendar } from 'pages/my-calendars/components'
import { userInfoSelector } from 'redux/selectors'
import { setCalendarId } from 'redux/actions'
import { ActivityRegion, ICalendar } from 'pages/my-calendars/add-calendar/interfaces'
import { LocationCalendars } from 'pages/my-calendars/add-calendar'
import { Layout } from 'shared/components/layout/Layout'
import { CalendarType, OpenBtnType } from 'pages/my-calendars/enums'
import { getDefaultLocationCalendar } from 'shared/utils'

export const InfoPage: FC = () => {
    const dispatch = useDispatch()
    const userInfoStore = useSelector(userInfoSelector)
    const { calendarId } = useParams<{ calendarId: string }>()
    const [regionData, setRegionData] = useState<ActivityRegion[]>([])
    const [calendarData, setCalendarData] = useState<ICalendar | null>(null)
    const [openBtnState, setOpenBtnState] = useState<OpenBtnType>(OpenBtnType.Shops)
    const [locationCalendars, setLocationCalendars] = useState<LocationCalendars[]>([
        getDefaultLocationCalendar()
    ])

    useEffect(() => {
        dispatch(setCalendarId(calendarId))
    }, [])

    return (
        <Layout userInfo={userInfoStore} showToolbar toolbarTitle={calendarData?.name || ''}>
            <Calendar
                type={CalendarType.INFO}
                calendarId={calendarId}
                openBtnState={openBtnState}
                regionData={regionData}
                calendarData={calendarData}
                locationCalendars={locationCalendars}
                isNeedToErase={false}
                setOpenBtnState={setOpenBtnState}
                setRegionData={setRegionData}
                setCalendarData={setCalendarData}
                setLocationCalendars={setLocationCalendars}
            />
        </Layout>
    )
}
